/**
 * Created by alex on 20.10.2016.
 */
import { State } from 'reducers'
import { LogObject } from 'lib/log'

const storage = localStorage

type LocalStorageValue = null | string | State | LogObject[]

/**
 * Get value from local storage by key
 */
const get = (key: string): LocalStorageValue => {
  try {
    const value = storage && storage.getItem(key)
    return value !== null ? JSON.parse(value) : value
  } catch {
    return null
  }
}

/**
 * Set value to local storage by key
 *  - the value will be stringified
 */
const set = (key: string, value: LocalStorageValue): void => {
  try {
    if (storage) {
      storage.setItem(key, JSON.stringify(value))
    }
  } catch {
    // silent fail
  }
}

/**
 * Remove the value from local storage by key
 *
 * @param {String} key
 */
const clear = (key: string): void => {
  if (key !== null) {
    if (storage) {
      storage.removeItem(key)
    }
  }
}

/**
 * Default export
 *
 * @return {{
 *  get: Function,
 *  set: Function,
 *  clear: Function
 * }}
 */
export default {
  get,
  set,
  clear,
}

/**
 * Export
 *
 * @return {{
 *  get: Function,
 *  set: Function,
 *  clear: Function
 * }}
 */
export { get, set, clear }
